import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import PolicyAnalysis from './pages/PolicyAnalysis';
import EnrollmentMap from './pages/EnrollmentMap';
import PolicySearch from './pages/PolicySearch';
import PolicyCalendar from './pages/PolicyCalendar';
import EmailAlerts from './pages/EmailAlerts';
import PayerContacts from './pages/PayerContacts';
import PolicyUpdates from './pages/PolicyUpdates';
import CoverageOverview from './pages/CoverageOverview';
import NationalCoverage from './pages/coverage/NationalCoverage';
import Layout from './components/Layout';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Dashboard data-id="element-4" />} data-id="element-3" />
          <Route path="/coverage" element={<CoverageOverview data-id="element-6" />} data-id="element-5" />
          <Route path="/coverage/national" element={<NationalCoverage data-id="element-8" />} data-id="element-7" />
          <Route path="/policy-analysis" element={<PolicyAnalysis data-id="element-10" />} data-id="element-9" />
          <Route path="/enrollment-map" element={<EnrollmentMap data-id="element-12" />} data-id="element-11" />
          <Route path="/policy-search" element={<PolicySearch data-id="element-14" />} data-id="element-13" />
          <Route path="/policy-calendar" element={<PolicyCalendar data-id="element-16" />} data-id="element-15" />
          <Route path="/email-alerts" element={<EmailAlerts data-id="element-18" />} data-id="element-17" />
          <Route path="/payer-contacts" element={<PayerContacts data-id="element-20" />} data-id="element-19" />
          <Route path="/policy-updates" element={<PolicyUpdates data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Layout>
    </Router>;
}